import React from 'react';
import { PatternFormat } from 'react-number-format';

const PhoneNoRenderer = ({ value }: { value: string | number | null }) => {
  const phoneNo = value == null ? '' : String(value);
  return (
    <PatternFormat
      value={phoneNo}
      format="+#-###-###-####"
      mask="_"
      displayType="text"
      renderText={(val) => <span>{val}</span>}
    />
  );
};

export default PhoneNoRenderer;